import Swal from "sweetalert2";

const Alerts = {};

Alerts.success = (title, message) => {
	Swal.fire(title, message, "success");
};
Alerts.error = (title, message) => {
	Swal.fire(title, message, "error");
};

Alerts.httpException = (exception) => {
	console.log({ exception });
	Swal.fire(
		"Could not process the request.",
		exception.response?.data?.error ?? "Please try again."
	);
};

export default Alerts;
